import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { IRecordLink } from '@soleran/common';
import { IModule, ModuleId } from '@soleran/module';
import { Subscription } from 'rxjs';
import { NavService } from '../../nav/nav.service';

import { GlobalSearchService } from '../global-search.service';
import { IRecordSearchResult } from '../record-search-result';

@Component({
  selector: 'app-advanced-search',
  template: `
    <mat-form-field>
      <mat-icon matPrefix class="search-prefix-icon">search</mat-icon>
      <input
        matInput
        solSearchInput
        [value]="control.value"
        [autofocus]="false"
        type="search"
        (searchValueChange)="onSearchValueChange($event)"
      />
    </mat-form-field>
    <app-module-picker
      [hint]="'Click or tap here to add more'"
      [label]="'Searching for Results in these Modules'"
      [modules]="modules"
      (selectedModuleIdsChange)="onSelectionChange($event)"
    ></app-module-picker>
    <app-advanced-search-record-table
      [term]="term"
      [pageSize]="pageSize"
      [moduleIds]="selectedModuleIds"
      (itemClick)="onItemClick($event)"
    ></app-advanced-search-record-table>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
      }
      .search-prefix-icon {
        position: relative;
        bottom: -6px;
      }
    `,
  ],
})
export class AdvancedSearchComponent implements OnInit, OnDestroy {
  @Input() set term(v: string) {
    this.control.setValue(v, { emitEvent: false });
  }
  get term() {
    return this.control.value;
  }
  @Output() itemClick = new EventEmitter<IRecordLink>();
  pageSize: number = 10;
  modules: IModule[] = [];
  selectedModuleIds: ModuleId[] = [];
  control = new UntypedFormControl('');
  private _subs: Subscription = new Subscription();
  constructor(private _gs: GlobalSearchService, private _nav: NavService) {}

  ngOnInit(): void {
    this._subs.add(this.control.valueChanges.subscribe((c) => (this.term = c)));
  }
  ngAfterViewInit(): void {
    this._subs.add(
      this._gs.getAppModules().subscribe((modules) => {
        this.modules = modules || [];
        this.selectedModuleIds = modules.map((m) => m.id);
      })
    );
  }
  onItemClick({
    event,
    item,
  }: {
    event: MouseEvent;
    item: IRecordSearchResult;
  }) {
    const { moduleId, recordId } = item.recordLink;
    const segments = ['/module', moduleId, 'detail', recordId];
    if (event.ctrlKey) {
      window.open(segments.join('/'), '_blank');
    } else {
      this.itemClick.emit({ moduleId, recordId });
      this._nav.to(segments);
    }
  }
  onSearchValueChange(term: string) {
    this.control.setValue(term);
  }
  onSelectionChange(ids: ModuleId[] | any) {
    this.selectedModuleIds = ids;
  }
  ngOnDestroy(): void {
    this._subs?.unsubscribe();
  }
}
